import { toast, Slide } from 'react-toastify'
import { Fade } from '../../components/common'
import GenerateAPIDForm from '../forms/GenerateAPIDForm'
import GeneratedAPIDsTable from '../../components/generateapid/GeneratedAPIDsTable'
import { getGenerateAPIDStatusProps } from '../../selectors/generateAPID'

const mapStateToProps = state => {
  const { submitted } = getGenerateAPIDStatusProps(state)
  return {
    submitted,
  }
}

const GenerateAPIDPage = ({ submitted }) => {
  useEffect(() => {
    if (submitted) {
      toast['success']('Successfully generated AP ID', {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 10000,
        transition: Slide,
      })
    }
  }, [submitted])

  return (
    <Fade>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h1>AP ID Generation</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <GenerateAPIDForm />
          </div>
        </div>
        <GeneratedAPIDsTable />
      </div>
    </Fade>
  )
}

export default connect(mapStateToProps, null)(GenerateAPIDPage)
